import React from 'react';
import { productPresentation } from '../data/tables';
import { productStats, coverage } from '../data/volumes';
export function ProductPresentation() {
  return <section aria-labelledby="product-heading" className="bg-white" data-id="element-189" data-mp="1pcitytqmua7j">
      <div className="mx-auto max-w-content px-5 py-16 sm:px-8 md:py-28" data-id="element-190" data-mp="1bgou107u6v6k">
        <span className="inline-block border border-brass/50 bg-paper px-3 py-1.5 font-mono text-[10px] uppercase leading-none tracking-label text-slate rounded-sharp" data-id="element-191" data-mp="1fhqvlnp87jbp">
          {productPresentation.badge}
        </span>

        <h2 id="product-heading" className="mt-7 max-w-[40rem] font-serif text-[30px] font-semibold leading-[1.12] tracking-[-0.015em] text-ink md:text-[46px]" data-id="element-192" data-mp="284v6uaewwtvx">
          {productPresentation.heading}
        </h2>

        <p className="mt-4 font-serif text-[22px] italic text-brass md:text-[26px]" data-id="element-193" data-mp="2m5e9t34it9r8">
          {productPresentation.tagline}
        </p>

        <p className="mt-7 max-w-[42rem] text-[17px] leading-[1.65] text-slate md:text-[18px]" data-id="element-194" data-mp="2qwnxvzaf8510">
          {productPresentation.body}
        </p>

        <ul className="mt-14 grid grid-cols-2 gap-x-8 gap-y-8 border-y border-brass/30 py-10 md:grid-cols-4" data-id="element-195" data-mp="2z7zb9wraz9lf">
          {productStats.map(stat => <li key={stat.label} data-id="element-196" data-mp="390x0smuppytj">
              <p className="font-mono text-[32px] font-medium leading-none text-ink md:text-[40px]" data-id="element-197" data-mp="392846lk8x4k4">
                {stat.value}
              </p>
              <p className="mt-2 font-mono text-[10px] uppercase tracking-label text-slate" data-id="element-198" data-mp="3i01xdnmpri32">
                {stat.label}
              </p>
            </li>)}
        </ul>

        <p className="mt-12 font-mono text-[10px] uppercase tracking-label text-slate" data-id="element-199" data-mp="3ryr8mxk3u4ac">
          Full coverage
        </p>
        <ul className="mt-4 flex flex-wrap gap-2" data-id="element-200" data-mp="3n0y0hyz8r07f">
          {coverage.map(chip => <li key={chip} className="border border-brass/50 border-b-[3px] border-b-brass bg-paper px-4 py-2 font-mono text-[11px] uppercase tracking-label text-ink rounded-t-sharp" data-id="element-201" data-mp="1xk6qarj9aku4">
              {chip}
            </li>)}
        </ul>
      </div>
    </section>;
}